import React from "react";
import { View, TouchableOpacity, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import ProgressBar from "./ProgressBar";
import StatusBadge from "./StatusBadge";
import { tokens, sharedStyles } from "../styles";

// Per-DB packing summary card — matches the prototype's PackingDBCard.
// Tap drills into the per-DB packing interface.

const PackingDBCard = ({ db, onPress }) => (
  <TouchableOpacity
    activeOpacity={0.85}
    onPress={() => onPress?.(db)}
    style={[sharedStyles.card]}
  >
    <View style={styles.headerRow}>
      <Text variant="title_16" style={styles.name} numberOfLines={1}>
        {db?.db_name || "—"}
      </Text>
      <StatusBadge
        label={
          db?.percent >= 100
            ? "Done"
            : db?.percent > 0
              ? "In Progress"
              : "Not Started"
        }
        state={
          db?.percent >= 100
            ? "packed"
            : db?.percent > 0
              ? "partial"
              : "neutral"
        }
      />
    </View>
    <View style={styles.progressBlock}>
      <View style={styles.progressMeta}>
        <Text variant="caption_2" style={styles.progressLabel}>
          {db?.packed || 0} / {db?.customers || 0} customers packed
        </Text>
        <Text variant="caption_2" style={styles.progressPercent}>
          {db?.percent || 0}%
        </Text>
      </View>
      <ProgressBar percent={db?.percent || 0} height={8} />
    </View>
    <View style={styles.kpiRow}>
      <Text variant="caption_2" style={styles.kpi}>
        👥 {db?.customers || 0} customers
      </Text>
    </View>
  </TouchableOpacity>
);

export default PackingDBCard;

const styles = StyleSheet.create({
  headerRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  name: {
    color: tokens.textPrimary,
    fontWeight: "700",
    flex: 1,
    marginRight: tokens.spacing.small,
  },
  progressBlock: { marginTop: tokens.spacing.medium },
  progressMeta: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 4,
  },
  progressLabel: { color: tokens.textSecondary, fontSize: 12 },
  progressPercent: {
    color: tokens.textPrimary,
    fontSize: 12,
    fontWeight: "700",
  },
  kpiRow: { flexDirection: "row", marginTop: tokens.spacing.medium },
  kpi: { color: tokens.textSecondary, fontSize: 12 },
});
